import React from "react";
import { Formik, Form } from "formik";
import { Stack } from "office-ui-fabric-react";
import NewFormField from "../../common/layout/form/NewFormField";
import PhonePrefixField, { ADMIN_PHONE_PREFIXES } from "../../common/layout/form/PhonePrefixField";
import { useAdminForm } from "../hooks/useAdminForm";
import NewFormBtns from "../../common/layout/form/NewFormBtns";
import ActivityIndicator from "../../common/layout/ActivityIndicator";
import MessageContainer from "../../auth/components/register/forms/MessageContainer";
import { useTranslation } from 'react-i18next';
import { validationSchemaDrivers } from "../actions/validationSchemas";
import { textfieldS } from "../../common/styles/formField.styles";

const AdminForm: React.FC = () => {
  const { t } = useTranslation('admin');
  const {
    handleSubmit,
    initValues,
    cancelForm,
    editedAdmin,
    loading
  } = useAdminForm();

  const validationTranslations = {
    lastNameRequired: t('admins.validation.lastNameRequired') as string,
    firstNameRequired: t('admins.validation.firstNameRequired') as string,
    phoneRequired: t('admins.validation.phoneRequired') as string,
    phoneInvalid: t('admins.validation.phoneInvalid') as string,
    emailRequired: t('admins.validation.emailRequired') as string,
    emailInvalid: t('admins.validation.emailInvalid') as string,
  };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaDrivers(validationTranslations)}
    >
      {({ handleSubmit }) => (
        <Form translate="yes" onSubmit={handleSubmit}>
          <Stack>
            <NewFormField name="lastName" label={t('admins.form.lastName') as string} />
            <NewFormField name="firstName" label={t('admins.form.firstName') as string} />
            <PhonePrefixField prefixName="phonePrefix" numberName="phone" label={t('admins.form.phone') as string} required={false} prefixOptions={ADMIN_PHONE_PREFIXES} textStyles={textfieldS} />
            <NewFormField name="email" label={t('admins.form.email') as string} />
            <NewFormBtns
              positionAbsolute={true}
              cancelForm={cancelForm}
              submitBtnText={editedAdmin ? t('admins.form.save') as string : t('admins.form.add') as string}
              disabled={loading}
            />
          </Stack>
          {loading ? <ActivityIndicator /> : <MessageContainer />}
        </Form>
      )}
    </Formik>
  );
};

export default AdminForm;